type User = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  address: string;
  password: string;
  title: string;
  department: string;
  companyName: string;
  googleId: string;
  country: string;
  companyLogo: string;
};

const user: User = {
  address: "",
  companyLogo: "",
  companyName: "",
  country: "",
  department: "",
  email: "",
  firstName: "",
  googleId: "",
  lastName: "",
  password: "",
  phone: "",
  title: "",
};

export type { User };

export { user };
